var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Buscador',_vm._b({attrs:{"prepend-icon":_vm.prepend,"color":"#27488e","append-icon":"search"}},'Buscador',Object.assign({}, _vm.$props, _vm.$attrs),false)),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }